import React, { useState } from "react";
import RCTQueueWidget from "../../doctor/RCTQueueWidget";
import ProcedureHistory from "../shared/ProcedureHistory";
import Button from "../../common/Button";
import "../Treatments.css";

export default function EndoManager() {
    const [showHistory, setShowHistory] = useState(false);

    return (
        <div className="mod-standalone-window" style={{ height: 'calc(100vh - 100px)', padding: '20px', display: 'flex', flexDirection: 'column' }}>
            <div className="mod-window-header" style={{ marginBottom: '20px', paddingBottom: 0, borderBottom: 'none' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <h2 style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>⚙️ Endodontics</h2>
                    <Button 
                        variant={showHistory ? "secondary" : "primary"}
                        onClick={() => setShowHistory(!showHistory)}
                    >
                        {showHistory ? 'Hide History' : '📜 History'}
                    </Button>
                </div>
            </div>

            <div style={{
                display: 'grid',
                gridTemplateColumns: showHistory ? '2fr 1fr' : '1fr',
                gap: '20px',
                flex: 1,
                minHeight: 0
            }}>
                <div className="mod-card" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <RCTQueueWidget groupByPatient onSelectPatient={() => { }} />
                </div>

                {showHistory && (
                    <div className="mod-card mod-panel-fade-in" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                        <ProcedureHistory
                            procedureType="RCT"
                            status="Completed"
                            title="Endo History (Completed)"
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
